module.exports = __webpack_public_path__ + "media/images/flags/co-0583d4c27d7fa8fa11f24789d27be259.svg";